import { useState, useCallback, useMemo } from 'react';
import { useAccessToken } from './useAccessToken';
import { useLogger } from '../context/useLogger';
import {
  EdiOctaveTiersService,
  EdiOctaveUser,
  ValidationResult,
} from '../services/EdiOctaveTiersService';

const useIsOctaveCodeValid = () => {
  const getAccessToken = useAccessToken();
  const [loading, setLoading] = useState(false);
  const logger = useLogger();

  const userEdiService = useMemo(
    () => new EdiOctaveTiersService(getAccessToken, logger),
    [getAccessToken, logger],
  );

  const validateLicense = useCallback(
    async (codeOctave: string, numSerieFacture: string): Promise<ValidationResult> => {
      setLoading(true);

      const userToSend: EdiOctaveUser = {
        DisplayName: 'User',
        CodeOctave: codeOctave,
        NumSerie: numSerieFacture,
        NumFacture: numSerieFacture,
      };

      const userResult = await userEdiService.tryFetchValidateTiersOctave(userToSend);
      setLoading(false);

      return userResult;
    },
    [userEdiService],
  );

  return { validateLicense, loading };
};

export default useIsOctaveCodeValid;
